var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg138Thunderbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.243,193.711c-7.943-17.294-24.785-28.037-43.952-28.037H323.08l80.803-135.489c3.68-6.168,3.761-13.837,0.214-20.081 C400.549,3.858,393.921,0,386.739,0H197.113c-7.519,0-14.402,4.226-17.802,10.933L79.966,206.826 c-11.117,21.828-10.111,47.329,2.69,68.214c12.803,20.885,35.069,33.353,59.565,33.353h69.865l-69.475,142.542 c-9.287,18.852-3.868,40.604,13.176,52.896c7.592,5.475,16.234,8.17,24.809,8.169c10.676,0,21.247-4.178,29.542-12.365 c0.362-0.358,0.712-0.73,1.045-1.114l154.695-178.034c7.231-8.322,6.346-20.929-1.975-28.16 c-8.324-7.232-20.931-6.347-28.16,1.975L181.667,471.625c-0.598,0.508-1.26,0.742-2.528-0.173 c-1.573-1.135-1.176-1.941-0.679-2.95l83.504-171.325c3.014-6.186,2.63-13.49-1.017-19.325 c-3.648-5.836-10.044-9.381-16.927-9.381h-101.8c-10.655,0-19.959-5.21-25.527-14.295c-5.568-9.084-5.989-19.74-1.139-29.265 l93.815-184.99h142.223L270.79,175.411c-3.68,6.168-3.761,13.837-0.214,20.081s10.175,10.103,17.357,10.103h103.357 c4.769,0,6.856,2.994,7.676,4.779c0.839,1.826,1.771,5.447-1.419,9.162c-7.183,8.364-6.226,20.966,2.137,28.149 c8.365,7.182,20.967,6.227,28.148-2.137C440.379,230.937,443.219,211.074,435.243,193.711z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg138Thunderbolt);
export default __webpack_public_path__ + "static/media/138-thunderbolt.6e46141134ce83a018be41dc95894b98.svg";
export { ForwardRef as ReactComponent };